import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ce32ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubTournamentCreation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Create Club Point Rules", -1))
const _hoisted_3 = { class: "clubTournamentContainer" }
const _hoisted_4 = { class: "layout gutter--lg clubTournamentInfoContainer" }
const _hoisted_5 = { class: "flex md2 xs2" }
const _hoisted_6 = { class: "flex md2 xs2" }
const _hoisted_7 = { class: "flex md2 xs2" }
const _hoisted_8 = { class: "flex md2 xs2" }
const _hoisted_9 = { class: "md2 xs2" }
const _hoisted_10 = { class: "row justify--space-around align--center" }
const _hoisted_11 = { class: "row justify--center align--center m2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_form, { ref: "form" }, {
          default: _withCtx(() => [
            _createElementVNode("form", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointRules, (rule, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row justify--space-evenly align--center",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_va_select, {
                      modelValue: rule.type,
                      "onUpdate:modelValue": ($event: any) => ((rule.type) = $event),
                      options: _ctx.typeOptions,
                      "text-by": (v) => v.name,
                      "value-by": (v) => v.value,
                      label: "Type*",
                      searchable: "",
                      bordered: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "text-by", "value-by"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_va_input, {
                      bordered: "",
                      type: "number",
                      modelValue: rule.start_range,
                      "onUpdate:modelValue": ($event: any) => ((rule.start_range) = $event),
                      modelModifiers: { number: true },
                      label: "Start-range*",
                      onKeypress: ($event: any) => (_ctx.onFieldEdit(rule.id)),
                      disabled: _ctx.checkForWinnerAndParticipation(rule.type)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeypress", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_va_input, {
                      bordered: "",
                      type: "number",
                      modelValue: rule.end_range,
                      "onUpdate:modelValue": ($event: any) => ((rule.end_range) = $event),
                      modelModifiers: { number: true },
                      label: "End-range*",
                      onKeypress: ($event: any) => (_ctx.onFieldEdit(rule.id)),
                      disabled: _ctx.checkForWinnerAndParticipation(rule.type)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeypress", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_va_input, {
                      bordered: "",
                      type: "number",
                      modelValue: rule.point,
                      "onUpdate:modelValue": ($event: any) => ((rule.point) = $event),
                      modelModifiers: { number: true },
                      label: "Point*",
                      onKeypress: ($event: any) => (_ctx.onFieldEdit(rule.id))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeypress"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_va_button, {
                      style: {"background-color":"transparent"},
                      disabled: _ctx.isDisabledToEdit(rule.id)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          onClick: ($event: any) => (_ctx.editField(rule)),
                          name: "edit_square",
                          color: "success"
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["disabled"]),
                    _createVNode(_component_va_icon, {
                      onClick: ($event: any) => (_ctx.removeField(index)),
                      name: "clear",
                      color: "danger"
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_va_button, {
                  color: "primary",
                  onClick: _ctx.addNewField
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      name: "add",
                      color: "white"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_va_button, {
                  class: "mr-4",
                  color: "secondary",
                  onClick: _ctx.backToPortal
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_va_button, {
                  class: "ml-4",
                  color: "success",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createPointRules(_ctx.retriveClubTournamentPointRules)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 512)
      ])
    ])
  ]))
}